import { Props, Context } from '../../../types';

export default function (props: Props, context: Context) {
    const text = 'Hello Drew';

    return {
        text,
    };
}